<div class="card infoEmpresa datos_element_to_target">
    <div class="card-header">
        <div class="row">
            <div class="col-8 text-left">
                <h1 class="d-none d-md-inline-block" translate>manager.compayInfoTitl</h1>
                <span class="d-inline-block d-md-none" translate>manager.compayInfoTitlMin</span>
                <span class="notaCabecera d-none d-sm-inline-block" translate>manager.compayInfoTitlAux</span>
            </div>
            <div class="col-4 text-right botonera">
                <button title="{{'manager.editCompany.dataRecharge' | translate}}" (click)="rechargeCompanyInfo()">
                    <i class="fa fa-refresh"></i></button>
            </div>
        </div>
    </div>

    <div class="card-body">
        <div class="datosEmpresa">
            <span class="nombre">{{ person.tradeName }}</span>
            <span class="codigo">{{ person.identifier }}</span>
            <span class="direccion">{{ person.address }}</span>
            <span class="telefonos">{{ person.phone }}</span>
        </div>
    </div>



// WEBPACK FOOTER //
// ./src/app/app-manager/client/cli-company-info/cli-company-info.component.html